module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "kp-select-open",
    attrs: {
      "to": {
        name: 'boxReportsMetrics',
        params: {
          locale: _vm.i18n.locale,
          boxId: _vm.box.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(_vm._s(_vm.$t('general.actions.report')) + "\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-9baaf296!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/item/ButtonReport.vue
 ** module id = 888
 ** module chunks = 1
 **/